import { RootState } from 'store/store';

export const selectServicesRequestServices = (state: RootState) => state.ServicesRequest.services || [];
export const selectServicesRequestAddress = (state: RootState) => state.ServicesRequest.address;
export const selectServicesRequestSqft = (state: RootState) => state.ServicesRequest.sqft;
export const selectServicesRequestMoveInDate = (state: RootState) => state.ServicesRequest.moveInDate;
export const selectServicesRequestHasMovedIn = (state: RootState) => state.ServicesRequest.hasMovedIn;
export const selectServicesRequestSetUp = (state: RootState) => state.ServicesRequest.setUp;
export const selectServicesRequestUser = (state: RootState) => state.ServicesRequest.user;
export const selectServicesRequestCompletedSteps = (state: RootState) => state.ServicesRequest.completedSteps;
export const selectExitModalIsVisible = (state: RootState) => state.ServicesRequest.exitModalIsVisible;
export const selectLaunchPath = (state: RootState) => state.ServicesRequest.launchPath;
export const selectServicesRequest = (state: RootState) => state.ServicesRequest;
